class _EventSubscription {
  /**
   * @param {EventSubscriptionVendor} subscriber the subscriber that controls
   *   this subscription.
   */
  constructor(subscriber) {
    this.subscriber = subscriber;
  }
  /**
   * Removes this subscription from the subscriber that controls it.
   */
  remove() {
    this.subscriber.removeSubscription(this);
  }
}
var EventSubscription_default = _EventSubscription;
export {
  EventSubscription_default as default
};
//# sourceMappingURL=_EventSubscription.js.map
